const formatMs = (ms) => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

export function Timer({ mode = 'countup', ms, className }) {
  return (
    <span className={className}>
      {mode === 'countdown' ? '⏳' : '⏱'} {formatMs(ms)}
    </span>
  );
}
